import { QuickStartGuide } from '@/core/sw-qsg/types';

export const qsgDataStructure : QuickStartGuide = {
  enable_qsg : true,
  close_screen: [
    {
      screen_id: 'close_screen',
      nodes: [
        {
          page_id: '',
          node_id: 'node_close',
          inline_css: { left: 'auto', top: '10px', right: '210px', width: '270px', height: '130px' },
          node_element: 'node_close_el',
          scroll_correction: true,
          node_animate_css: {
            animation_bc: 'node_close_element',
            opacity: '0',
            animation_fill_mode_bc: 'forwards',
            animation_duration_bc: '0.8s',
            animation_delay_bc: '1s',
            animation_direction_bc: 'normal',
          },
          keyframe: {
            name: 'node_close_element',                       // name value should match animation_bc value
            breakpoints: [
              {
                range: '0%',
                properties: {
                  opacity: '1',
                  top: '400px',
                },
              },
              {
                range: '100%',
                properties: {
                  opacity: '1',
                  top: '27px',                        // top value should match node's location top value
                },
              },
            ],
          },
          title: {
            title_value: 'QuickStart Guide',
            inline_css: { left: 'auto', top: '10px', right: '255px', width: '200px', height: 'auto' },
          },
          description: {
            description_value: 'Acessing QuickStart Guide anytime under User (avatar) dropdown menu',
            inline_css: { left: 'auto', top: '45px', right: '255px', width: '200px', height: 'auto' },
          },
          media: [
            {
              media_id: 'right_arrow',
              media_path: 'right_arrow.png',
              inline_css: { left: 'auto', top: '40px', right: '210px', width: '26px', height: 'auto' },
            },
          ],
          multimedia: [
            {                        // multimedia for video playback
              multimedia_id: '',
              multimedia_position: {
                inline_css: {},
              },
              node_animate_css: {
                animation_bc: '',
                opacity: '',
                animation_fill_mode_bc: '',
                animation_duration_bc: '',
                animation_delay_bc: '',
                animation_direction_bc: '',
              },
              keyframe: {
                name: '',
                breakpoints: [
                  {
                    range: '',
                    properties: {
                      opacity: '',
                      top: '',
                    },
                  },
                  {
                    range: '',
                    properties: {
                      opacity: '',
                      top: '',
                    },
                  },
                ],
              },
              icon_path: '',
              icon_position: {
                inline_css: {},
              },
              icon_text: '',
              icon_text_position: {
                inline_css: {},
              },
              video_path: '',
              video_position: {
                inline_css: {},
              },
            },
          ],
        },
      ],
    },
  ],
  screens : [
    {
      screen_id: 'screen_1',
      path_name: '/workspace/m/feature/unified-insights',  //  /m/dashboard/overview/status/console  //  /m/nsm/devices/device-management
      qsgStoreCall: false,
      nodes: [{
        page_id: 'screen_1_page_1',
        node_id: 'screen_1_page_1_node_1',
        // inline_css: { left: '205px', top: '5px', right: 'auto', width: '220px', height: '185px' },
        inline_css: {},
        node_element: 'sw-nav-standalone-collapse-trigger',
        scroll_correction: true,
        node_animate_css: {
          animation_bc: 'screen_1_page_1_node_1_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '0.2s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_1_node_1_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                // top: '0px',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Hamburger',
          inline_css: { left: '378px', top: '17px', right: 'auto', width: 'auto', height: 'auto' },
        },
        description: {
          description_value: 'Collapse the Left-Nav for better experience',
          inline_css: { left: '325px', top: '54px', right: 'auto', width: '220px', height: 'auto' },
        },
        media: [
          {
            media_id: 'hamburger_icon',
            media_path: 'hamburger_icon.png',
            node_element: 'sw-nav-standalone-collapse-trigger',
            inline_css: { position: 'static' },
          }, {
            media_id: 'hamburger_arrow',
            media_path: 'arrow-2.png',
            inline_css: { left: '134px', top: '-121px', right: 'auto', width: '80px', height: 'auto', transform: 'rotate(-95deg)' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_1_page_1',
        node_id: 'screen_1_page_1_node_2',
        inline_css: {},
        node_element: 'sw-qsg-el-crumbs',
        scroll_correction: true,
        node_animate_css: {
          animation_bc: 'screen_1_page_1_node_2_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '1.6s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_1_node_2_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Tenant Selector',
          inline_css: { left: '75px', top: '122px', right: 'auto', width: '190px', height: 'auto' },
        },
        description: {
          description_value: 'Review Dashboards for any of your tenants',
          inline_css: { left: '25px', top: '155px', right: 'auto', width: '295px', height: 'auto' },
        },
        media: [
          {
            media_id: 'tenant_selector',
            media_path: 'crumbs2.png',
            node_element: 'sw-qsg-el-crumbs',
            inline_css: { position: 'static', width: 'auto' },
          }, {
            media_id: 'menu_icon_arrow',
            media_path: 'arrow-curve.svg',
            inline_css: { left: '80px', top: '28px', right: 'auto', width: '94px', height: 'auto', transform: 'rotate(8deg)' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '0',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_1_page_1',
        node_id: 'screen_1_page_1_node_3',
        inline_css: {},
        node_element: 'sw-qsg-el-help',
        scroll_correction: true,
        node_animate_css: {
          animation_bc: 'screen_1_page_1_node_3_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '2.4s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_1_node_3_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Help Center',
          inline_css: { left: 'auto', top: '138px', right: '-13px', width: '190px', height: 'auto' },
        },
        description: {
          description_value: 'Context Sensitive and Interactive Help System',
          inline_css: { left: 'auto', top: '173px', right: '-22px', width: '212px', height: 'auto' },
        },
        media: [
          {
            media_id: 'notification_icon',
            media_path: 'Help.png',
            node_element: 'sw-qsg-el-help',
            inline_css: { position: 'static' },
          }, {
            media_id: 'menu_icon_arrow',
            media_path: 'arrow-curve.svg',
            inline_css: { left: 'auto', top: '42px', right: '2px', width: '92px', height: 'auto', transform: 'scaleX(-1) rotate(12deg)' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '0',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_1_page_2',
        node_id: 'screen_1_page_2_node_1',
        inline_css: {},
        node_element: 'Firewall-TopApplications',
        scroll_correction: true,
        node_animate_css: {
          animation_bc: 'screen_1_page_2_node_1_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '0.2s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_2_node_1_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Widget Operations',
          inline_css: { left: '27%', top: '330px', right: 'auto', width: '295px' },
        },
        description: {
          description_value: '<div>1. Drag and Drop across the Dashboard </br> 2. Remove or replace Widgets </br> 3. Modify how data is grouped </br> 4. Drill down to investigate</br></div>', // tslint:disable-line
          inline_css: { left: '27%', top: '365px', right: 'auto', width: '295px', height: 'auto' },
        },
        media: [
          {
            media_id: 'inventory_selector',
            media_path: 'firewall_top_applications.png',
            node_element: 'Firewall-TopApplications',
            inline_css: { position: 'static', height: 'auto' },
          },
        ], multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_1_page_3',
        node_id: 'screen_1_page_3_node_1',
        inline_css: {},
        node_element: 'sw-qsg-el-refresh',
        scroll_correction: true,
        node_animate_css: {
          animation_bc: 'screen_1_page_3_node_1_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '0.4s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_3_node_1_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Dashboard Management',
          inline_css: { left: '160px', top: '247px', right: 'auto', width: '320px' },
        },
        description: {
          description_value: '<div>5. Refresh the dashboard </br> 6. Export as a PDF Report </br> 7. Add a new Widget to your Dashboard </br> 8. Save changes made to your Dashboard</div>',  // tslint:disable-line
          inline_css: { left: '160px', top: '284px', right: 'auto', width: '320px', height: 'auto' },
        },
        media: [
          {
            media_id: 'inventory_table_index',
            media_path: 'dash-refresh.png',
            node_element: 'sw-qsg-el-refresh',
            inline_css: { position: 'static' },
          }, {
            media_id: 'inventory_table_index_arrow',
            media_path: 'c5.png',
            inline_css: { left: 'auto', top: '20px', right: '20px', width: '20px', height: 'auto' },
          }, {
            media_id: 'inventory_table_index_arrow',
            media_path: 'a5.png',
            inline_css: { left: 'auto', top: '46px', right: '-224px', width: '258px', height: 'auto' },
          },
        ], multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_1_page_3',
        node_id: 'screen_1_page_3_node_2',
        inline_css: {},
        node_element: 'sw-qsg-el-export',
        scroll_correction: true,
        node_animate_css: {
          animation_bc: 'screen_1_page_3_node_2_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '1s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_3_node_2_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: '',
          inline_css: { },
        },
        description: {
          description_value: '',
          inline_css: { },
        },
        media: [
          {
            media_id: 'column_selection',
            media_path: 'dash-export.png',
            node_element: 'sw-qsg-el-export',
            inline_css: { position: 'static' },
          }, {
            media_id: 'column_selection_arrow',
            media_path: 'c6.png',
            inline_css: { left: 'auto', top: '20px', right: '58px', width: '20px', height: 'auto' },
          }, {
            media_id: 'column_selection_arrow',
            media_path: 'a6.png',
            inline_css: { left: 'auto', top: '46px', right: '-66px', width: '138px', height: 'auto' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_1_page_3',
        node_id: 'screen_1_page_3_node_3',
        inline_css: {},
        node_element: 'sw-qsg-el-insert-widget',
        scroll_correction: true,
        node_animate_css: {
          animation_bc: 'screen_1_page_3_node_3_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '1s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_3_node_3_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: '',
          inline_css: { },
        },
        description: {
          description_value: '',
          inline_css: { },
        },
        media: [
          {
            media_id: 'column_selection',
            media_path: 'dash-insert-widget.png',
            node_element: 'sw-qsg-el-insert-widget',
            inline_css: { position: 'static' },
          }, {
            media_id: 'column_selection_arrow',
            media_path: 'c7.png',
            inline_css: { left: 'auto', top: '20px', right: '52px', width: '20px', height: 'auto' },
          }, {
            media_id: 'column_selection_arrow',
            media_path: 'a7.png',
            inline_css: { left: 'auto', top: '46px', right: '62px', width: 'auto', height: '196px', transform: 'rotate(3deg)' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_1_page_3',
        node_id: 'screen_1_page_3_node_4',
        inline_css: {},
        node_element: 'sw-qsg-el-save-dashboard',
        scroll_correction: true,
        node_animate_css: {
          animation_bc: 'screen_1_page_3_node_4_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '1s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_3_node_4_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: '',
          inline_css: { },
        },
        description: {
          description_value: '',
          inline_css: { },
        },
        media: [
          {
            media_id: 'column_selection',
            media_path: 'dash-save-layout.png',
            node_element: 'sw-qsg-el-save-dashboard',
            inline_css: { position: 'static' },
          }, {
            media_id: 'column_selection_arrow',
            media_path: 'c8.png',
            inline_css: { left: 'auto', top: '20px', right: '103px', width: '20px', height: 'auto' },
          }, {
            media_id: 'column_selection_arrow',
            media_path: 'a8.png',
            inline_css: { left: 'auto', top: '41px', right: '114px', width: 'auto', height: '205px', transform: 'rotate(3deg)' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_1_page_4',
        node_id: 'screen_1_page_4_node_1',
        inline_css: {},
        node_element: 'sw-qsg-el-reports',
        scroll_correction: false,
        node_animate_css: {
          animation_bc: 'screen_1_page_4_node_1_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '0.2s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_4_node_1_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Reports',
          inline_css: { left: '443px', top: '30px', right: 'auto', width: '265px' },
        },
        description: {
          description_value: 'Generate and schedule reports for all managed products', // tslint:disable-line
          inline_css: { left: '443px', top: '65px', right: 'auto', width: '265px', height: 'auto' },
        },
        media: [
          {
            media_id: 'inventory_selector',
            media_path: 'nav_reports.png',
            node_element: 'sw-qsg-el-reports',
            inline_css: { position: 'static', height: 'auto' },
          }, {
            media_id: 'column_selection_arrow',
            media_path: 'a4.png',
            inline_css: { left: 'auto', top: '-55px', right: '-135px', width: 'auto', height: '205px', transform: 'rotate(86deg)' },
          },
        ], multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_1_page_4',
        node_id: 'screen_1_page_4_node_2',
        inline_css: {},
        node_element: 'sw-qsg-el-reports-compact',
        scroll_correction: false,
        node_animate_css: {
          animation_bc: 'screen_1_page_4_node_2_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '0.2s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_1_page_4_node_2_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Reports',
          inline_css: { left: '270px', top: '30px', right: 'auto', width: '265px' },
        },
        description: {
          description_value: 'Generate and schedule reports for all managed products', // tslint:disable-line
          inline_css: { left: '270px', top: '65px', right: 'auto', width: '265px', height: 'auto' },
        },
        media: [
          {
            media_id: 'inventory_selector',
            media_path: 'nav_reports_compact.png',
            node_element: 'sw-qsg-el-reports-compact',
            inline_css: { position: 'static', height: 'auto' },
          }, {
            media_id: 'column_selection_arrow',
            media_path: 'a4.png',
            inline_css: { left: 'auto', top: '-55px', right: '-135px', width: 'auto', height: '205px', transform: 'rotate(86deg)' },
          },
        ], multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      },
      ],
    }, {
      screen_id: 'screen_2',
      path_name: '/workspace/m/feature/unified-reports',  //  /m/dashboard/overview/status/console  //  /m/nsm/devices/device-management
      qsgStoreCall: false,
      nodes: [{
        page_id: 'screen_2_page_1',
        node_id: 'screen_2_page_1_node_1',
        inline_css: {},
        node_element: 'sw-qsg-el-reports-action',
        scroll_correction: false,
        node_animate_css: {
          animation_bc: 'screen_2_page_1_node_1_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '0.2s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_2_page_1_node_1_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Edit Report',
          inline_css: { left: '-74px', top: '244px', right: 'auto', width: 'auto', height: 'auto' },
        },
        description: {
          description_value: 'Edit Report Tasks',
          inline_css: { left: '-110px', top: '278px', right: 'auto', width: '160px', height: 'auto', textAlign: 'right' },
        },
        media: [
          {
            media_id: 'tenant_selector',
            media_path: 'reports_action.png',
            node_element: 'sw-qsg-el-reports-action',
            inline_css: { position: 'static' },
          }, {
            media_id: 'menu_icon_arrow',
            media_path: 'a4.png',
            inline_css: { left: '-21px', top: '31px', right: 'auto', width: 'auto', height: '210px', transform: 'rotate(180deg)' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '0',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_2_page_1',
        node_id: 'screen_2_page_1_node_2',
        // inline_css: { left: '205px', top: '5px', right: 'auto', width: '220px', height: '185px' },
        inline_css: {},
        node_element: 'sw-qsg-el-crt',
        scroll_correction: false,
        node_animate_css: {
          animation_bc: 'screen_2_page_1_node_2_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '1.6s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_2_page_1_node_2_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                // top: '0px',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Create Report Task',
          inline_css: { left: '-180px', top: '180px', right: 'auto', width: 'auto', height: 'auto' },
        },
        description: {
          description_value: 'Create an On-demand or Scheduled Report',
          inline_css: { left: '-180px', top: '213px', right: 'auto', width: '170px', height: 'auto' },
        },
        media: [
          {
            media_id: 'hamburger_icon',
            media_path: 'create_report_task.png',
            node_element: 'sw-qsg-el-crt',
            inline_css: { position: 'static' },
          }, {
            media_id: 'hamburger_arrow',
            media_path: 'arrow-curve.svg',
            inline_css: { left: '-93px', top: '47px', right: 'auto', width: '130px', height: 'auto', transform: 'scaleX(-1) rotate(13deg)' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_2_page_1',
        node_id: 'screen_2_page_1_node_3',
        inline_css: {},
        node_element: 'sw-qsg-el-reports-download',
        scroll_correction: false,
        node_animate_css: {
          animation_bc: 'screen_2_page_1_node_3_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '2.4s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_2_page_1_node_3_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Reports Download',
          inline_css: { left: 'auto', top: '138px', right: '60px', width: '190px', height: 'auto' },
        },
        description: {
          description_value: 'Bulk Download/Delete Reports',
          inline_css: { left: 'auto', top: '172px', right: '72px', width: '162px', height: 'auto' },
        },
        media: [
          {
            media_id: 'notification_icon',
            media_path: 'reports_download.png',
            node_element: 'sw-qsg-el-reports-download',
            inline_css: { position: 'static' },
          }, {
            media_id: 'menu_icon_arrow',
            media_path: 'arrow-curve.svg',
            inline_css: { left: 'auto', top: '43px', right: '70px', width: '90px', height: 'auto', transform: 'scaleX(-1) rotate(12deg)' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '0',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      }, {
        page_id: 'screen_2_page_1',
        node_id: 'screen_2_page_1_node_4',
        inline_css: {},
        node_element: 'sw-qsg-el-report-task',
        scroll_correction: false,
        node_animate_css: {
          animation_bc: 'screen_2_page_1_node_4_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '3s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_2_page_1_node_4_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Report Task',
          inline_css: { left: 'auto', top: '215px', right: '-90px', width: '140px', height: 'auto' },
        },
        description: {
          description_value: 'Show Report Task History',
          inline_css: { left: 'auto', top: '248px', right: '-102px', width: '162px', height: 'auto' },
        },
        media: [
          {
            media_id: 'notification_icon',
            media_path: 'report_task.png',
            node_element: 'sw-qsg-el-report-task',
            inline_css: { position: 'static' },
          }, {
            media_id: 'menu_icon_arrow',
            media_path: 'a4.png',
            inline_css: { left: 'auto', top: '35px', right: '-11px', width: 'auto', height: '170px', transform: 'scaleX(-1) rotate(178deg)' },
          },
        ],
        multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '0',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      },
      ],
    },
  ],
};

/*
{
      screen_id: 'screen_2',
      path_name: '/m/catp/dashboard_hide',
      nodes: [{
        page_id: 'screen_2_page_1',
        node_id: 'screen_2_page_1_node_1',
        inline_css: {},
        node_element: 'sw-qsg-el-file-types-card',
        scroll_correction: false,
        node_animate_css: {
          animation_bc: 'screen_2_page_1_node_1_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '0.2s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_2_page_1_node_1_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                // top: '0px',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Hamburger',
          inline_css: { left: '50%', top: '455px', right: 'auto', width: '100%', height: 'auto', transform: 'translate(-50%)' },
        },
        description: {
          description_value: 'Collapse/Expand LeftNav to gain more space',
          inline_css: { left: '50%', top: '490px', right: 'auto', width: '220px', height: 'auto', transform: 'translate(-50%)' },
        },
        media: [
          {
            media_id: 'file_types_card_icon',
            media_path: 'catp-file-types.png',
            node_element: 'sw-qsg-el-file-types-card',
            inline_css: { position: 'static' },
          }, {
            media_id: 'arrow',
            media_path: 'Picture14.png',
            inline_css: { left: 'auto', top: '376px', right: '250px', height: '75px', transform: 'rotate(180deg) scaleX(-1)' },
          },
        ],
        multimedia: {
          multimedia_id: 'file_types_card_video',
          multimedia_position: {
            inline_css: { left: '50%', top: '554px', right: 'auto', width: '140px', height: '38px', transform: 'translate(-50%)' },
          },
          node_animate_css: {
            animation_bc: 'screen_2_page_1_node_1_multimedia',
            opacity: '0',
            animation_fill_mode_bc: 'forwards',
            animation_duration_bc: '0.8s',
            animation_delay_bc: '1s',
            animation_direction_bc: 'normal',
          },
          keyframe: {
            name: 'screen_2_page_1_node_1_multimedia',                       // name value should match animation_bc value
            breakpoints: [
              {
                range: '0%',
                properties: {
                  opacity: '1',
                  top: '400px',
                },
              },
              {
                range: '100%',
                properties: {
                  opacity: '1',
                  top: '0px',
                },
              },
            ],
          },
          icon_path: '', // icon_path: 'Icon_HandPointer_BlueFill_1.svg',
          icon_position: {
            inline_css: { width: '26px', height: 'auto', transform: 'rotate(0deg)' },
          },
          icon_text: 'Show me',
          icon_text_position: {
            inline_css: { left: '40px', top: '7px', right: 'auto' },
          },
          icon_ripple: {
            inline_css: { left: '3px', top: '7px', right: 'auto' },
          },
          video_path: 'hamburger.mp4',
          video_position: {
            inline_css: { width: '30%', height: 'auto' },
          },
        },
      }, {
        page_id: 'screen_2_page_1',
        node_id: 'screen_2_page_1_node_2',
        inline_css: {},
        node_element: 'sw-qsg-el-insights-card',
        scroll_correction: false,
        node_animate_css: {
          animation_bc: 'screen_2_page_1_node_2_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '1.6s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_2_page_1_node_2_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: 'Hamburger',
          inline_css: { left: '50%', top: '455px', right: 'auto', width: '100%', height: 'auto', transform: 'translate(-50%)' },
        },
        description: {
          description_value: 'Collapse/Expand LeftNav to gain more space',
          inline_css: { left: '50%', top: '490px', right: 'auto', width: '220px', height: 'auto', transform: 'translate(-50%)' },
        },
        media: [
          {
            media_id: 'notification_icon',
            media_path: 'catp-insights.png',
            node_element: 'sw-qsg-el-insights-card',
            inline_css: { position: 'static' },
          }, {
            media_id: 'menu_icon_arrow',
            media_path: 'Picture14.png',
            inline_css: { left: 'auto', top: '376px', right: '290px', height: '75px', transform: 'rotate(180deg) scaleX(-1)' },
          },
        ],
        multimedia: {
          multimedia_id: 'catp_insights_video',
          multimedia_position: {
            inline_css: { left: '50%', top: '554px', right: 'auto', width: '140px', height: '38px', transform: 'translate(-50%)' },
          },
          node_animate_css: {
            animation_bc: 'screen_2_page_1_node_2_multimedia',
            opacity: '0',
            animation_fill_mode_bc: 'forwards',
            animation_duration_bc: '0.8s',
            animation_delay_bc: '1.6s',
            animation_direction_bc: 'normal',
          },
          keyframe: {
            name: 'screen_2_page_1_node_2_multimedia',
            breakpoints: [
              {
                range: '0%',
                properties: {
                  opacity: '1',
                  top: '400px',
                },
              },
              {
                range: '100%',
                properties: {
                  opacity: '1',
                  top: '0px',
                },
              },
            ],
          },
          icon_path: '', // icon_path: 'Icon_HandPointer_BlueFill_1.svg',
          icon_position: {
            inline_css: { width: '26px', height: 'auto', transform: 'rotate(0deg)' },
          },
          icon_text: 'Show me',
          icon_text_position: {
            inline_css: { left: '40px', top: '7px', right: 'auto' },
          },
          icon_ripple: {
            inline_css: { left: '2px', top: '4px', right: 'auto' },
          },
          video_path: 'hamburger.mp4',
          video_position: {
            inline_css: { width: '30%', height: 'auto' },
          },
        },
      },
      ],
    },
*/

/*
{
        page_id: 'screen_3_page_1',
        node_id: 'screen_3_page_1_node_3',
        // inline_css: { left: '205px', top: '5px', right: 'auto', width: '220px', height: '185px' },
        component_name: 'DashboardOverviewDevice',
        inline_css: {},
        node_element: 'ssw-qsg-el-fw-overview-online-managed',
        scroll_correction: false,
        node_animate_css: {
          animation_bc: 'screen_3_page_1_node_3_element',
          opacity: '0',
          animation_fill_mode_bc: 'forwards',
          animation_duration_bc: '0.8s',
          animation_delay_bc: '1.2s',
          animation_direction_bc: 'normal',
        },
        keyframe: {
          name: 'screen_3_page_1_node_3_element',                       // name value should match animation_bc value
          breakpoints: [
            {
              range: '0%',
              properties: {
                opacity: '1',
                top: '400px',
              },
            },
            {
              range: '100%',
              properties: {
                opacity: '1',
                // top: '0px',
                top: 'getBoundingClientRect',
              },
            },
          ],
        },
        title: {
          title_value: '',
          inline_css: {},
        },
        description: {
          description_value: 'Number of online and synchronized devices',
          inline_css: { left: '40px', top: '137px', right: 'auto', width: '330px', height: 'auto' },
        },
        media: [
          {
            media_id: 'device_overview_groups',
            media_path: 'device_overview_groups.jpeg',
            node_element: 'sw-qsg-el-fw-overview-online-managed',
            inline_css: { position: 'static' },
          }, {
            media_id: 'device_overview_groups_arrow',
            media_path: 'arrow-curve.svg',
            inline_css: { left: '79px', top: '57px', right: 'auto', width: '80px', height: 'auto' },
          },
        ], multimedia: [
          {
            multimedia_id: '',
            multimedia_position: {
              inline_css: {},
            },
            node_animate_css: {
              animation_bc: '',
              opacity: '',
              animation_fill_mode_bc: '',
              animation_duration_bc: '',
              animation_delay_bc: '',
              animation_direction_bc: '',
            },
            keyframe: {
              name: '',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
                {
                  range: '',
                  properties: {
                    opacity: '',
                    top: '',
                  },
                },
              ],
            },
            icon_path: '',
            icon_position: {
              inline_css: {},
            },
            icon_text: '',
            icon_text_position: {
              inline_css: {},
            },
            icon_ripple: {
              inline_css: {},
            },
            video_path: '',
            video_position: {
              inline_css: {},
            },
          },
        ],
      },
*/

/*
------------- Hamburgur Multimedia --------------
multimedia: [
          {
            multimedia_id: 'hamburger_video',
            multimedia_position: {
              inline_css: { left: '337px', top: '370px', right: 'auto', width: '140px', height: '38px' },
            },
            node_animate_css: {
              animation_bc: 'screen_1_page_1_node_1_multimedia_0',
              opacity: '0',
              animation_fill_mode_bc: 'forwards',
              animation_duration_bc: '0.8s',
              animation_delay_bc: '1s',
              animation_direction_bc: 'normal',
            },
            keyframe: {
              name: 'screen_1_page_1_node_1_multimedia_0',                       // name value should match animation_bc value
              breakpoints: [
                {
                  range: '0%',
                  properties: {
                    opacity: '1',
                    top: '400px',
                  },
                },
                {
                  range: '100%',
                  properties: {
                    opacity: '1',
                    top: '0px',
                  },
                },
              ],
            },
            icon_path: 'Icon_HandPointer_BlueFill_1.svg', // icon_path: 'Icon_HandPointer_BlueFill_1.svg',
            icon_position: {
              inline_css: { width: '26px', height: 'auto', transform: 'rotate(-24deg)' },
            },
            icon_text: 'Show me',
            icon_text_position: {
              inline_css: { left: '40px', top: '7px', right: 'auto' },
            },
            icon_ripple: {
              inline_css: { left: '3px', top: '7px', right: 'auto' },
            },
            video_path: 'https://nsm-ore-production-video.s3-us-west-2.amazonaws.com/hamburger.mp4', // hamburger.mp4
            video_position: {
              inline_css: { width: '30%', height: 'auto' },
            },
          },
        ],
*/
